import { SchoolCalendarFieldEnum as Fields } from 'Common/FieldEnum';

export const shouldUpdateMbeDate = (
  currentCalendar,
  previousCalendar,
  currentExceptions,
  previousExceptions
) => {
  if (currentCalendar[Fields.MbeComplete]) {
    return false;
  }

  if (!currentCalendar[Fields.MbeEnabled]) {
    return false;
  }

  if (!previousCalendar[Fields.MbeEnabled]) {
    return true;
  }

  if (
    currentCalendar[Fields.MbeOperationalDays] !==
    previousCalendar[Fields.MbeOperationalDays]
  ) {
    return true;
  }

  if (
    currentCalendar[Fields.FirstDayDT] !== previousCalendar[Fields.FirstDayDT]
  ) {
    return true;
  }

  return exceptionsHaveChanged(currentExceptions, previousExceptions);
};

export const exceptionsHaveChanged = (current, previous) => {
  if (current.length !== previous.length) {
    return true;
  }

  for (const currException of current) {
    const prevException = previous.find(
      e =>
        e[Fields.BeginDay] === currException[Fields.BeginDay] &&
        e[Fields.EndDay] === currException[Fields.EndDay] &&
        e[Fields.Description] === currException[Fields.Description]
    );

    if (!prevException) {
      return true;
    } else {
      if (prevException[Fields.BeginDay] !== currException[Fields.BeginDay]) {
        return true;
      }

      if (prevException[Fields.EndDay] !== currException[Fields.EndDay]) {
        return true;
      }
    }
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/helpers/index.js